import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useAuth } from 'react-oidc-context';

export default function Navbar() {
  const auth = useAuth();

  const handleLogout = () => {
    auth.signoutRedirect(); // use .removeUser() for local-only logout
  };

  return (
    <AppBar position="sticky" color="primary" sx={{ backgroundColor: '#fff', color: '#000' }} elevation={1}>
      <Toolbar>
        {/* Logo / Title on the left */}
        <Box
          display="flex"
          alignItems="center"   // Vertically center
          justifyContent="center" // Horizontally center (optional)
          width='168px'
        >
          <img src="/trustap_logo_new.svg" alt='Trustap Logo' width="168" />
        </Box>

        {/* Spacer to push logout to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Logout button on the right */}
        {auth.isAuthenticated && (
          <Box>
            <Button color="primary" variant="outlined" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
